module.exports = __webpack_public_path__ + "img/23.874125e1.png";